import { Link } from "react-router-dom";
import Logo from "../../../Assets/Images/logo.svg";

const Error403 = () => {
  return (
    <section className='login-page'>
      <div className='container' style={{ paddingTop: "70px" }}>
        <div className='shadow-lg rounded-2' style={{ height: "650px" }}>
          <div className='row w-100 m-0'>
            <div className='col-12 col-md-6'>
              <div className='d-flex flex-column ' style={{ height: "100%" }}>
                <div className='my-5 d-flex flex-row justify-content-center align-items-cenetr'>
                  <img src={Logo} alt='logo' className='w-50' />
                </div>
                <h1 className='text-dark  f-16 mb-5 font-weight-bold text-center'>
                  شما به این صفحه دسترسی ندارید
                </h1>
              </div>
            </div>
            <div className='col-12 col-md-6'>
              <div className='row bg-white rounded-2 mt-md-5 shadow mx-3 pt-5'>
                <div className='col-12'>
                  <div className='d-flex flex-row justify-content-between align-items-center'>
                    <span className='h-line-2 w-30'></span>
                    <h1 className='text-dark-blue mx-2 f-16 font-weight-bold'>
                      دسترسی غیر مجاز
                    </h1>
                    <span className='h-line-2 w-30'></span>
                  </div>
                </div>
                <div className='col-12 mt-3'>
                  <h2 className='text-dark-blue f-14 line-height-3'>
                    شما مجوز دیدن این صفحه را ندارید برای بازگشت به صفحه اصلی بر
                    روری دکمه بازگشت کلیک کنید.
                  </h2>
                </div>
                <div className='col-12'>
                  <span
                    style={{ fontSize: "50px" }}
                    className='text-dark font-weight-bold d-flex flex-row justify-content-center align-items-center'
                  >
                    Access Forbidden
                  </span>
                  <span
                    style={{ fontSize: "150px" }}
                    className='text-dark font-weight-bold d-flex flex-row justify-content-center align-items-center'
                  >
                    403
                  </span>
                </div>

                <div className='col-12 my-3'>
                  <Link
                    to='/'
                    type='submit'
                    className='btn bg-blue-sky-fill border rounded-1 w-100'
                  >
                    <i></i>
                    بازگشت
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Error403;
